import {
    Alarm,
    ArrowFatLinesRight,
    Certificate,
    Check,
    Clock,
    DeviceMobile,
    FileText,
    Gear,
    HourglassMedium,
    Info,
    ListBullets,
    MapPin,
    MapTrifold,
    Pulse,
    Stack,
    Star,
    Student,
    UserCircle,
    UsersThree,
    X,
    DotsThreeOutline,
    Calendar,
    SlidersHorizontal,
    BellSimpleRinging,
    Toolbox,
    Lifebuoy,
    CheckFat,
    Anchor,
    Users,
    Pen,
    Database,
    MagnifyingGlass,
    Boat,
    Archive,
    ListMagnifyingGlass,
    ClipboardText,
    Medal
} from "phosphor-react-sc"
import {
    EvaluationDuotoneIcon,
    MapSegmentsDuotoneIcon,
    ShipDuotoneIcon
} from '../../../icons/Icons';
import { SvgIcon } from "@progress/kendo-react-common";
import { CalendarDot, CalendarDots, CalendarStar } from "@phosphor-icons/react";

interface BottomMenuIconProps {
    icon: string
}

// todo: swap with IconPicker
export const BottomMenuIcon = ({ icon }: BottomMenuIconProps) => {

    return (
        (() => {
            switch (icon) {
                case "alarmClock":
                    return <Alarm size={32} weight="duotone" />
                case "anchor":
                    return <Anchor size={32} weight="duotone" />
                case "archive":
                    return <Archive size={32} weight="duotone" />
                case "bell-simple-ringing":
                    return <BellSimpleRinging size={32} weight="duotone" />
                case "boat":
                    return <Boat size={32} weight="duotone" />
                case "bulletList":
                    return <ListBullets size={32}  />
                case "calendar":
                    return <Calendar size={32} weight="duotone" />
                case "calendar-dot":
                    return <CalendarDot size={32} weight="duotone" />
                case "calendar-dots":
                    return <CalendarDots size={32} weight="duotone" />
                case "calendar-star":
                    return <CalendarStar size={32} weight="duotone" />
                case "certificate":
                    return <Certificate size={32} weight="duotone" />
                case "check":
                    return <CheckFat size={32} weight="duotone" />
                case "clock":
                    return <Clock size={32} weight="duotone" />
                case "database":
                    return <Database size={32} weight="duotone" />
                case "dots":
                    return <DotsThreeOutline size={32} weight="duotone" />
                case "document":
                    return <FileText size={32} weight="duotone" />
                case "evaluation":
                    return <SvgIcon icon={EvaluationDuotoneIcon} size="xlarge" />
                case "hourglass":
                    return <HourglassMedium size={32} weight="duotone" />
                case "information":
                    return <Info size={32} weight="duotone" />
                case "lifebuoy":
                    return <Lifebuoy size={32} weight="duotone" />
                case "map":
                    return <MapTrifold size={32} weight="duotone" />
                    case "medal":
                    return <Medal size={32} weight="duotone" />
                case "mapSegments":
                    return <SvgIcon icon={MapSegmentsDuotoneIcon} size="xlarge" />
                case "mobile":
                    return <DeviceMobile size={32} weight="duotone" />
                case "myPage":
                    return <UserCircle size={32} weight="duotone" />
                case "next":
                    return <ArrowFatLinesRight size={32} weight="duotone" />
                case "ok":
                    return <Check size={32} />
                case "pen":
                    return <Pen size={32} weight="duotone" />
                case "pin":
                    return <MapPin size={32} weight="duotone" />
                case "pulse":
                    return <Pulse size={32} weight="duotone" />
                case "settings":
                    return <Gear size={32} weight="duotone" />
                case "ship":
                    return <SvgIcon icon={ShipDuotoneIcon} size="xlarge" />
                case "sliders-horizontal":
                    return <SlidersHorizontal size={32} weight="duotone" />
                case "stack":
                    return <Stack size={32} weight="duotone" />
                case "star":
                    return <Star size={32} weight="duotone" />
                case "student":
                    return <Student size={32} weight="duotone" />
                case "toolbox":
                    return <Toolbox size={32} weight="duotone" />
                case "users-three":
                    return <UsersThree size={32} weight="duotone" />
                case "users":
                    return <Users size={32} weight="duotone" />
                case "search":
                    return <MagnifyingGlass size={32} weight="duotone" />
                case "list-magnifying-glass":
                    return <ListMagnifyingGlass size={32} weight="duotone" />
                case "clipboard-text":
                    return <ClipboardText size={32} weight="duotone" />
                default:
                    return <X size={32}  />
            }
        })()
    )
}
